import {graphql} from 'gatsby'
import DetailsTemplate from './details.template'

export const query = graphql`
  query ($id: String!, $maxPrice: Float!, $minPrice: Float!) {
    product: wpProduct(id: {eq: $id}) {
      id
      databaseId
      name: title
      slug
      description: content
      gallery {
        id
        url: sourceUrl
      }
      acf {
        isSold: issold
        isForSale: isforsale
        isForRent: isforrent
        addressNumber: addressnumber
        street {
          ... on WpStreet {
            name: title
          }
        }
        ward {
          ... on WpWard {
            name: title
          }
        }
        district {
          ... on WpDistrict {
            name: title
          }
        }
        province {
          ... on WpProvince {
            name: title
          }
        }
        directions {
          ... on WpDirection {
            name: title
          }
        }
        categories {
          ... on WpProductCategory {
            name: title
          }
        }
        thumbnail {
          url: sourceUrl
          mimeType
          altText
          mediaDetails {
            height
            width
          }
        }
        area
        numberOfBathrooms: numberofbathrooms
        numberOfBedrooms: numberofbedrooms
        price
        brief
        youtubeUrl: youtubeurl
      }
      seo {
        metaDesc
        metaKeywords
      }
    }
    streets: allWpStreet(sort: {fields: title, order: ASC}) {
      edges {
        node {
          id
          title
        }
      }
    }
    districts: allWpDistrict(sort: {fields: title, order: ASC}) {
      edges {
        node {
          title
          id
        }
      }
    }
    wards: allWpWard(sort: {fields: title, order: ASC}) {
      edges {
        node {
          id
          title
          acf {
            district {
              ... on WpDistrict {
                id
              }
            }
          }
        }
      }
    }
    relatedProducts: allWpProduct(
      filter: {
        status: {eq: "publish"},
        acf: {
          price: {lte: $maxPrice, gte: $minPrice},
          issold: {ne: true}
        },
        id: {ne: $id}
      },
      sort: {fields: acf___price, order: DESC},
      limit: 12,
    ) {
      edges {
        node {
          id
          name: title
          slug
          acf {
            isSold: issold
            isForSale: isforsale
            isForRent: isforrent
            addressNumber: addressnumber
            street {
              ... on WpStreet {
                name: title
              }
            }
            ward {
              ... on WpWard {
                name: title
              }
            }
            district {
              ... on WpDistrict {
                name: title
              }
            }
            province {
              ... on WpProvince {
                name: title
              }
            }
            directions {
              ... on WpDirection {
                name: title
              }
            }
            thumbnail {
              url: sourceUrl
              alt: altText
              mediaDetails {
                width
                height
              }
            }
            area
            numberOfBathrooms: numberofbathrooms
            numberOfBedrooms: numberofbedrooms
            price
          }
        }
      }
    }
  }
`

export default DetailsTemplate
